/**
 * Internal dependencies
 */
import SpacingInputControl from './spacing-input-control';
import { getPresetValueFromCustomValue } from '../utils';
import { type SpacingSize } from '../../../utils';

type SingleInputControlProps = {
	readonly minimumCustomValue: number;
	readonly onChange: ( values: Record< string, string | undefined > ) => void;
	readonly onMouseOut?: ( event: React.SyntheticEvent ) => void;
	readonly onMouseOver?: ( event: React.SyntheticEvent ) => void;
	readonly showSideInLabel?: boolean;
	readonly side: string;
	readonly spacingSizes: Array< SpacingSize >;
	readonly type?: string;
	readonly values: Record<
		'top' | 'right' | 'bottom' | 'left',
		string | undefined
	>;
	readonly disabledSides: Record<
		'top' | 'right' | 'bottom' | 'left',
		boolean
	>;
};
export default function SingleInputControl( {
	minimumCustomValue,
	onChange,
	onMouseOut,
	onMouseOver,
	showSideInLabel,
	side,
	spacingSizes,
	type,
	values,
	disabledSides,
}: SingleInputControlProps ): JSX.Element {
	type Values = SingleInputControlProps[ 'values' ];
	const createHandleOnChange =
		( currentSide: keyof Values ) => ( next?: string ) => {
			// Encode the existing value into the preset value if the passed in value matches the value of one of the spacingSizes.
			const nextValues: Values = {
				...Object.keys( values )
					.filter( ( k ): k is keyof Values => !! k )
					.reduce( ( acc, key ) => {
						acc[ key ] = getPresetValueFromCustomValue(
							values[ key ],
							spacingSizes
						);
						return acc;
					}, {} as Values ),
			};

			nextValues[ currentSide ] = next;

			onChange( nextValues );
		};

	return (
		<SpacingInputControl
			minimumCustomValue={ minimumCustomValue }
			onChange={ createHandleOnChange( side as keyof Values ) }
			onMouseOut={ onMouseOut }
			onMouseOver={ onMouseOver }
			showSideInLabel={ showSideInLabel }
			side={ side }
			spacingSizes={ spacingSizes }
			type={ type }
			value={ values[ side as keyof Values ] }
			disabled={ disabledSides[ side as keyof Values ] }
		/>
	);
}
